import "../css/style.scss";
import FaqScript from "./modules/faq";
import SubscriptionUser from "./modules/subscription";

const nesubs = new SubscriptionUser
const faqSec = new FaqScript
